module.exports = __webpack_public_path__ + "img/hc_pro_ten_15.c398d866.jpg";